// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const DEFAULT_URL = "https://jdcnjtvrndnbhpblikms.supabase.co";
const DEFAULT_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpkY25qdHZybmRuYmhwYmxpa21zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEzNDU2NjEsImV4cCI6MjA3NjkyMTY2MX0.Qej4nxwj-VW8P-GOz6_5NYNV3wldo4093H4XtLtYK80";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const SUPABASE_URL = import.meta.env.VITE_ENV_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL || DEFAULT_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_ENV_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || DEFAULT_PUBLISHABLE_KEY;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});